import { useTranslation } from 'react-i18next';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import AppRoutes from 'config/AppRoutes';
import PageLayout from 'ui/layout/PageLayout';
import { useDispatch, useSelector } from 'react-redux';
import { updateBill } from 'store/answers/answersSlice';
import { AddressPostcodeSelector, PanelSelector } from 'store/selectors';
import PanelIndicator from 'components/PanelIndicator';
import {
  calculateConsumptionBaseOnBill,
  getEstimatedPanelsForConsumption,
} from 'utils/calculation/calculation';
import useGetRegionPrice from 'api/useGetRegionPrice';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import usePanelList from '../PagePanel/hooks/usePanelList';
import useBillConfig from './hooks/useBillConfig';

const PageBillInfoDefault = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { navigateToNextStep } = useStepNavigation(AppRoutes.CONSUMPTION);
  const addressPostCode = useSelector(AddressPostcodeSelector);
  const panelList = usePanelList();
  const panelId = useSelector(PanelSelector);
  const regionPrice = useGetRegionPrice(addressPostCode);
  const { default: defaultBillAmount } = useBillConfig();
  const calculatedConsumption = calculateConsumptionBaseOnBill(
    defaultBillAmount,
    regionPrice
  );

  // --------------------- methods ------------------------

  const handleContinue = () => {
    dispatch(updateBill(defaultBillAmount));
    navigateToNextStep();
  };

  return (
    <PageLayout
      title={t('BILL_INFO_default')}
      buttonLabel={t('common.continue')}
      buttonCallback={handleContinue}
      backButton
      backRoute={AppRoutes.CONSUMPTION}
    >
      {/* <Image src={step_bill} alt="bill-selection" /> */}

      <Flex gap="10px" flexDir="column" alignItems="center">
        <HStack userSelect="none">
          <Text
            color="primaryColor"
            border="none"
            fontSize={100}
            fontFamily="Primary Bold"
            textAlign="center"
            height="100px"
            lineHeight="120px"
          >
            {defaultBillAmount}
          </Text>

          <Flex height="100%" alignItems="end">
            <Text
              color="primaryColor"
              fontSize={16}
              fontWeight="bold"
              fontFamily="Primary Regular"
            >
              {t('BILL_INFO_euro')}
            </Text>
          </Flex>
        </HStack>
        <Text
          color="black"
          border="none"
          fontFamily="Primary Regular"
          textAlign="center"
        >
          {t('BILL_INFO_default_description')}
        </Text>
        <Box
          position="relative"
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <PanelIndicator
            textPosition="right"
            amount={getEstimatedPanelsForConsumption(
              panelId,
              panelList,
              calculatedConsumption
            )}
            txt={t('common.panels')}
            position="unset"
            alignSelf="center"
          />
        </Box>
      </Flex>
    </PageLayout>
  );
};

export default PageBillInfoDefault;
